import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaCogs, FaScrewdriver, FaBrush, FaCheckCircle, FaPhone } from 'react-icons/fa'; // Ícones para Reforma de Mecanismo
import { LuPiano } from "react-icons/lu";
import SeoHead from "../../components/Menu/components/SeoHead";
import '../../assets/css/reformececanismo.css'; 

const ReformaMecanismo = () => {

  // Array com as imagens da galeria
const galleryImages = [
  { 
    id: 1, 
    src: '/img/mecanismo/1.jpg', 
    alt: 'Revisão completa dos martelos e cabeçotes para garantir som perfeito.' 
  },
  { 
    id: 2, 
    src: '/img/mecanismo/2.jpg', 
    alt: 'Ajustes precisos para que as peças trabalhem em harmonia e segurança.' 
  },
  { 
    id: 3, 
    src: '/img/mecanismo/3.jpg', 
    alt: 'Substituição de peças danificadas com materiais de alta qualidade.' 
  },
];

const mecanismoSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Reforma do Mecanismo de Piano",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Waldir Pianos",
    "image": "https://pianoswaldir.com.br/images/logo.jpg"
  },
  "description": "Restauração completa dos componentes internos do piano, incluindo martelos, abafadores e molas, para melhorar a qualidade do som e o aspecto visual.",
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "São Paulo"
  },
  "url": "https://pianoswaldir.com.br/reforma-mecanismo"
};




   const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Auto-rotatividade das imagens
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % galleryImages.length
        );
      }
    }, 5000); // Muda a cada 5 segundos
    
    return () => clearInterval(interval);
  }, [isHovered]);

  const currentImage = galleryImages[currentImageIndex];

  return (
    
    <div className="reforma-mecanismo-container">
      <SeoHead
  title="Reforma do Mecanismo de Piano | Waldir Pianos"
  description="Restauração e substituição de componentes internos do seu piano para otimizar a qualidade do som e a funcionalidade. Devolva a vida ao seu instrumento."
  keywords="reforma mecanismo piano, martelos piano, abafadores piano, restauração piano, conserto piano, Waldir Pianos"
  image="/img/mecanismo/1.jpg" 
  url="https://pianoswaldir.com.br/reforma-mecanismo"
  canonicalUrl="https://pianoswaldir.com.br/reforma-mecanismo"
  schemaMarkup={mecanismoSchema}
/>
      {/* Cabeçalho */}
      <motion.header
        className="reforma-mecanismo-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="reforma-mecanismo-header-content">
          <motion.h1
            className="reforma-mecanismo-main-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <FaCogs className="reforma-mecanismo-title-icon" />
            Reforma do Mecanismo
            <span className="reforma-mecanismo-title-decoration"></span>
          </motion.h1>

          <motion.p
            className="reforma-mecanismo-header-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            A vida nova para o coração do seu piano
          </motion.p>
        </div>
      </motion.header>

      {/* Conteúdo Principal */}
      <div className="reforma-mecanismo-main-content">
        {/* Seção de Texto */}
        <motion.section
          className="reforma-mecanismo-text-section"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        >
          <motion.div
            className="reforma-mecanismo-text-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <h2 className="reforma-mecanismo-section-title">
              <FaScrewdriver className="reforma-mecanismo-section-icon" />
              Restaurando a Performance Sonora
            </h2>

            <p className="reforma-mecanismo-classic-text">
              "Considera-se mecanismo de um piano o conjunto de componentes internos que interligam o acionamento de uma tecla (nota) á uma corda."
            </p>

            <div className="reforma-mecanismo-modern-text">
              <p>São responsáveis por essa movimentação mecânica complexa os martelos, abafadores, molas, correias, camurças e pivôs e diversos outros milhares de pequenos componentes.</p>
              <p>Com o uso ao longo dos anos, é natural que alguns destes componentes se desgastem. A reforma no mecanismo consiste na limpeza, restauração ou substituição destes, garantindo além de uma melhoria na qualidade do som, um melhor aspecto visual.</p>
            </div>

            <div className="reforma-mecanismo-benefits-grid">
              <div className="reforma-mecanismo-benefit-item">
                <FaCogs className="reforma-mecanismo-benefit-icon" />
                <span>Restauração completa de componentes</span>
              </div>
              <div className="reforma-mecanismo-benefit-item">
                <FaBrush className="reforma-mecanismo-benefit-icon" />
                <span>Melhora na qualidade sonora</span>
              </div>
              <div className="reforma-mecanismo-benefit-item">
                <FaCheckCircle className="reforma-mecanismo-benefit-icon" />
                <span>Aspecto visual renovado do interior</span>
              </div>
            </div>
          </motion.div>
        </motion.section>

<motion.section
        className="armazenagem-gallery-section"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.7 }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <h3 className="armazenagem-gallery-title">Restauração de Mecanismos</h3>
        
        <motion.div 
          className="armazenagem-gallery-container"
          key={currentImageIndex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <div className="armazenagem-piano-image">
            <img 
              src={currentImage.src} 
              alt={currentImage.alt}
              className="armazenagem-gallery-image"
            />
            <div className="armazenagem-image-overlay">
              <span className="armazenagem-piano-description">
                {currentImage.alt}
              </span>
            </div>
          </div>
        </motion.div>
        
        {/* Pontos de navegação */}
        <div className="armazenagem-gallery-dots">
          {galleryImages.map((_, index) => (
            <button
              key={index}
              className={`armazenagem-dot ${index === currentImageIndex ? 'armazenagem-dot-active' : ''}`}
              onClick={() => setCurrentImageIndex(index)}
            />
          ))}
        </div>
      </motion.section>
      </div>

      {/* Rodapé */}
      <motion.footer
        className="reforma-mecanismo-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p className="reforma-mecanismo-footer-text">Seu piano precisa de uma nova vida?</p>
        <motion.a
          href="tel:1122565987"
          className="reforma-mecanismo-contact-button"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPhone /> Fale Conosco
        </motion.a>
      </motion.footer>
    </div>
  );
};

export default ReformaMecanismo;